import { isFunction } from 'lodash';

import { store as MyQuizzes } from './my-quizzes';
import { store as VideoLectures } from './video-lectures';
import { store as VideoCourses } from './video-courses';
import { store as Evaluations } from './evaluations';
import { store as Assignments } from './assignments';
import { store as Publishers } from './publishers';
import { store as MyCards } from './my-cards';
import { store as EditPage } from './edit-page';
import { store as Classes } from './classes';
import { store as Auth } from './auth';
import Tutorials from './tutorials';
import ClEvents from './cl-events';
import Advertisements from './advertisements';
import BrowseFilters from './browse-filters';
import Notifications from './notifications';
import CustomCards from './custom-cards';
import StoreCards from './store-cards';
import StorePages from './store-pages';
import Policies from './policies';

const store = {
  MyQuizzes,
  Advertisements,
  BrowseFilters,
  Notifications,
  VideoLectures,
  VideoCourses,
  Evaluations,
  Assignments,
  CustomCards,
  Publishers,
  StoreCards,
  StorePages,
  MyCards,
  Classes,
  Auth,
  Tutorials,
  ClEvents,
  Policies,
  EditPage,
};
const keys = Object.keys(store);

const modules = keys.reduce((acc, key) => ({ ...acc, [key]: store[key].module }), {});
const plugins = keys.reduce((acc, key) => [...acc, store[key].plugin], []).filter(isFunction);

export default { modules, plugins };



// WEBPACK FOOTER //
// ./src/app/store.js